import { render, staticRenderFns } from "./SignUpSection.vue?vue&type=template&id=689ef055"
import script from "./SignUpSection.vue?vue&type=script&lang=js"
export * from "./SignUpSection.vue?vue&type=script&lang=js"
import style0 from "./SignUpSection.vue?vue&type=style&index=0&id=689ef055&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports